import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useColorStore } from "@/classes/useColorStore.js";
import { usePageStore } from "@/stores/pageStore.js";
import { resolveThemeTokens } from "@/themes/registry.js";

// Theme-level design tokens (typography, the --t-* contract), as opposed to
// useBrandCssVars' per-tenant palette. Set once at the page root, same pattern
// as brand colors. The business's own two colours go where the theme decides.
export function useThemeTokens() {
    const { theme } = storeToRefs(useColorStore());
    const pageStore = usePageStore();
    return computed(() => resolveThemeTokens(theme.value, pageStore.pageData?.brandColors || {}, pageStore.pageData?.look));
}
